/** White "in" glyph for circular social buttons on mentor profile. */
export const LinkedInInIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden
  >
    <path d="M6.5 8.5h3v9h-3v-9zm1.5-4.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5zM10 8.5h2.9v1.23h.04c.4-.77 1.38-1.58 2.84-1.58 3.04 0 3.6 2 3.6 4.61V17.5h-3v-4.02c0-.96-.02-2.2-1.34-2.2-1.34 0-1.55 1.05-1.55 2.13v4.09H10V8.5z" />
  </svg>
);
